var _circle, _circle2, _circle3, _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiccessImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 171,
    viewBox: "0 0 211 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 34,
    r: 5,
    fill: "#EAEEF9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 121,
    r: 9,
    fill: "#EAEEF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 27,
    r: 6,
    fill: "#EAEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.375 90C175.375 100.396 173.105 110.272 169.028 119.145C157.979 143.257 133.63 160 105.375 160C77.1196 160 52.7709 143.257 41.7223 119.145C37.6453 110.272 35.375 100.396 35.375 90C35.375 51.3392 66.7142 20 105.375 20C144.036 20 175.375 51.3392 175.375 90Z",
    fill: "#F2F6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2334_6914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 20,
    width: 141,
    height: 140
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.375 90C175.375 100.396 173.105 110.272 169.028 119.145C157.979 143.257 133.63 160 105.375 160C77.1196 160 52.7709 143.257 41.7223 119.145C37.6453 110.272 35.375 100.396 35.375 90C35.375 51.3392 66.7142 20 105.375 20C144.036 20 175.375 51.3392 175.375 90Z",
    fill: "#EAEEF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2334_6914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6458 108.375H141.104L153.5 119.75H57.25L69.6458 108.375Z",
    fill: "#C0CFF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 65.5,
    width: 64.75,
    height: 71.75,
    rx: 3,
    fill: "#C4D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.375 119.75H57.25V208.125H153.5V119.75H127.25L123.75 131.125H87.875L84.375 119.75Z",
    fill: "url(#paint0_linear_2334_6914)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1743 103.464C93.7926 102.846 94.7951 102.846 95.4134 103.464L100.627 108.678L115.341 93.9644C115.959 93.3461 116.962 93.3461 117.58 93.9644C118.198 94.5827 118.198 95.5852 117.58 96.2036L101.747 112.037C101.128 112.655 100.126 112.655 99.5076 112.037L93.1743 105.704C92.5559 105.085 92.5559 104.083 93.1743 103.464Z",
    fill: "#5578C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2334_6914",
    x1: 107.894,
    y1: 205.444,
    x2: 107.747,
    y2: 145.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiccessImage);
export default __webpack_public_path__ + "static/media/siccess_image.717bb35c27ab242ecfb827886e7710ce.svg";
export { ForwardRef as ReactComponent };